let adminPermissionsList = [];

const RolePlugin = {
  setPermissions(role, permissions) {
    adminPermissionsList = permissions || [];
  },
  removePermissions() {
    adminPermissionsList = [];
  },
  can(permission) {
    if (Array.isArray(permission)) {
      return adminPermissionsList.some((perm) => adminPermissionsList.indexOf(perm) > -1);
    }
    return adminPermissionsList.indexOf(permission) > -1;
  },
};

export default function (Vue) {
  Vue.role = RolePlugin;

  Object.defineProperties(Vue.prototype, {
    $role: {
      get() {
        return Vue.role;
      },
    },
  });
}
